import React from 'react';
import { Alert, Box, Button, Container, Paper, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useVendorStatus } from '../hooks/useVendorStatus';
import MarketingSurface from '../components/MarketingSurface';
import { marketingColor, marketingFont } from '../theme/marketingTokens';

/**
 * Dedicated lockout for a rejected vendor org.
 * Product APIs and /app routes are blocked; support is the petition path.
 */
export const AccountLockedPage: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { organization } = useVendorStatus();

  return (
    <MarketingSurface>
      <Container component="main" maxWidth="sm">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Paper sx={{ padding: 4, width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                <img
                  src="/logo-white.svg"
                  alt="Motzu Labs"
                  style={{
                    height: '28px',
                    width: 'auto',
                    maxWidth: '160px',
                  }}
                  onError={(e) => {
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                    const parent = target.parentElement;
                    if (parent) {
                      parent.innerHTML = `<span style="font-family: ${marketingFont.display}; font-weight: 700; font-size: 1.25rem; color: ${marketingColor.text};">Motzu Labs</span>`;
                    }
                  }}
                />
              </Box>
              <Alert severity="error" sx={{ width: '100%' }}>
                <Typography variant="h6" gutterBottom>
                  Account Locked
                </Typography>
                <Typography variant="body1">
                  Your vendor application has been rejected. Access to Motzu APIs and the app has been
                  suspended.
                </Typography>
                {organization?.name && (
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    Organization: {organization.name}
                  </Typography>
                )}
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Contact support if you want this decision reviewed. There is no self-serve retry.
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, mt: 2, flexWrap: 'wrap' }}>
                  <Button variant="contained" color="inherit" onClick={() => navigate('/contact')}>
                    Contact support
                  </Button>
                  <Button color="inherit" onClick={() => logout().then(() => navigate('/login'))}>
                    Sign out
                  </Button>
                </Box>
              </Alert>
            </Box>
          </Paper>
        </Box>
      </Container>
    </MarketingSurface>
  );
};

export default AccountLockedPage;
